import { Injectable } from '@angular/core';
import { Constants } from '../core/helper/Constants';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {

  constructor(private http: HttpClient) { }

  fakeTranslate(messages): Promise<Object> {
    //because we usually use deutsch, we don't want any german-english words (e.g Homeoffice, Hometrainer)
    //translated into german words (e.g Heimbuero), so we skip the translation.
    const fakeTranslation = [];
    for (const text of messages) {
      fakeTranslation.push({
        'detected_source_language': 'DE',
        'text': text
      })
    }
    const fakeDeeplResponse = {
      "translations": fakeTranslation
    }
    const fakeResponse = [{
      translations: fakeDeeplResponse,
      language: 'deutsch'
    }]
    return new Promise((resolve) => {
      resolve(fakeResponse);
    })

  }

  /**
  * function to use deepl to translate messages with language of choice
  * @param messages messages that are going to be translated
  * @param lang language 
  * @returns 
  */
  async deeplTranslate(messages, lang) {
    try{
      //throw new Error("Error in deeplTranslate deeplMonaTranslation/ googleCloudTranslation-1");
  
      if (lang != 'arabisch' && lang != "kroatisch" && lang != "serbisch" && lang != "albanisch" && lang != "kasachisch" && lang != "afrikaans" && lang != "hindi" && lang != "malayalam") {
        console.log("schick weg with deeplMonaTranslation");
        const body = {
          text: messages,
          TargetLang: lang
        };
        return this.http.post('https://us-central1-mona-ai-pwa-firebase.cloudfunctions.net/deeplMonaTranslation', body, {
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
          },
        }).toPromise();
      } else {
        console.log("schick weg with  googleCloudTranslation-1");
        const googleBody = {
          text: messages,
          targetLang: lang
        };
        return this.http.post('https://us-central1-mona-ai-pwa-firebase.cloudfunctions.net/googleCloudTranslation-1', googleBody, {
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
          },
        }).toPromise();
      }
    }catch (error) {
      console.warn("Error in deeplTranslate deeplMonaTranslation/ googleCloudTranslation-1: ", error);
   }       
  }

  /**
   * Translate messages with google translate only as deepl does not support some of the languages in which the message is written by the user
   * @param messages 
   * @param lang 
   * @returns 
   */
  async translateOnlyWithGoogle(messages, lang) {
    console.log("schick weg with translateOnlyWithGoogle");
    const googleBody = {
      text: messages,
      targetLang: lang
    };
    return this.http.post('https://us-central1-mona-ai-pwa-firebase.cloudfunctions.net/googleCloudTranslation-1', googleBody, {
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      },
    }).toPromise();
  }

  static findSourceLangCode(language) {
    let langCode = "DE";
 if (language == "deutsch") {
                langCode = "DE";
            } else if (language == "englisch") {
                langCode = "EN-GB";
            } else if (language == "französisch") {
                langCode = "FR";
            } else if (language == "bulgarisch") {
                langCode = "BG";
            } else if (language == "ukrainisch") {
                langCode = "UK";
            } else if (language == "türkisch") {
                langCode = "TR";
            } else if (language == "rumänisch") {
                langCode = "RO";
            } else if (language == "polnisch") {
                langCode = "PL";
            } else if (language == "slowakisch") {
                langCode = "SK";
            } else if (language == "arabisch") {
                langCode = "DE";
            } else if (language == "ungarisch") {
                langCode = "HU";
            } else if (language == "tschechisch") {
                langCode = "CS";
            } else if (language == "portugiesisch") {
                langCode = "PT-PT";
            } else if (language == "portugisisch") {
                langCode = "PT-PT";
            } else if (language == "italienisch") {
                langCode = "IT";
            } else if (language == "holländisch") {
                langCode = "NL";
            } else if (language == "spanisch") {
                langCode = "ES";
            } else if (language == "russisch") {
                langCode = "RU";
            } else if (language == "dänisch") {
                langCode = "DA";
            } else if (language == "schwedisch") {
                langCode = "SV";
            } else if (language == "chinesisch") {
                langCode = "ZH";
            } else if (language == "indonesisch") {
                langCode = "ID";
            } else if (language == "litauisch") {
                langCode = "LT";
            } else if (language == "estnisch") {
                langCode = "ET";
            }

            return langCode;
  }

  async deeplTranslateWithSourceLang(messages, lang, sourceLang) {
    try {
     // throw new Error("Error in deeplTranslate deeplMonaTranslation/ googleCloudTranslation-1");
  
      console.log("deeplTranslateWithSourceLang sourceLang: ", sourceLang, 'messages: ', messages, 'language to be translated in : ', lang);
      if (lang != 'arabisch' && lang != "kroatisch" && lang != "serbisch" && lang != "albanisch" && lang != "kasachisch" && lang != "afrikaans" && lang != 'hindi' && lang != 'malayalam') {
        console.log("deeplTranslateWithSourceLang schick weg with deeplMonaTranslation");
        const body = {
          text: messages,
          TargetLang: lang,
          sourceLang: TranslationService.findSourceLangCode(sourceLang)
        };
        return this.http.post('https://us-central1-mona-ai-pwa-firebase.cloudfunctions.net/deeplMonaTranslation', body, {
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
          },
        }).toPromise();
      } else {
        console.log("deeplTranslateWithSourceLang schick weg with googleCloudTranslation-1");
        const googleBody = {
          text: messages,
          targetLang: lang,
          sourceLang: sourceLang
        };
        return this.http.post('https://us-central1-mona-ai-pwa-firebase.cloudfunctions.net/googleCloudTranslation-1', googleBody, {
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*'
          },
        }).toPromise();
      }
    } catch (error) {
      console.error("Error in deeplTranslateWithSourceLang deeplMonaTranslation/ googleCloudTranslation-1: ", error);
      await this.translateOnlyWithGoogle(messages, lang);
    }    
  }

  /**
   * function that uses google translate to translate messages
   * @param messages messages that are going to be translated
   * @param langs language
   */
  googleTranslate(messages, langs) {
    const body = {
      messages: messages,
      langs: langs
    };

    fetch('https://us-central1-mona-ai-pwa-firebase.cloudfunctions.net/googleTranslate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })
      .then(response => response.json())
      .then(values => {
        console.log(values);
      })
      .catch(error => {
        console.error(Constants.ERROR_CLOUDFUNCTION_MESSAGE, error);
      });
  }

  /**
   * Method to check if a string contains only numbers and special characters, we use this method to skip translation if needed
   * @param string 
   * @returns true if the string contains only numbers and special characters, false otherwise
   */
  checkIfStringContainsOnlyNumbersAndSpecialCharacters(string: string) {
    return /^[0-9!@#\$%\^\&*\)\(+=._-]+$/.test(string);
  }
}
